module.exports = require("@splunk/charting-bundle");